import { MagistralDrug } from '@dreryk/drerykweb-medicine-api';

import { hasRpwMagistralDrugInMedicineRawMaterials } from '~libs.shared.prescription';
import { MedicineName } from '~libs.desktop.shared.medicine';

type MagistralDrugHeadingProps = Pick<MagistralDrug, 'magistralDrugMedicineRawMaterials'> & {
   readonly name: string;
};

export const MagistralDrugHeading = (props: MagistralDrugHeadingProps): JSX.Element => {
   const rpw = hasRpwMagistralDrugInMedicineRawMaterials(props.magistralDrugMedicineRawMaterials);

   return <MedicineName name={props.name} atc={rpw ? 'RPW' : 'OTHER'} testId={'magistralDrugName'} />;
};
